import { render, staticRenderFns } from "./PermissionUnitsRepeater.vue?vue&type=template&id=d484d146&scoped=true"
import script from "./PermissionUnitsRepeater.vue?vue&type=script&lang=js"
export * from "./PermissionUnitsRepeater.vue?vue&type=script&lang=js"
import style0 from "./PermissionUnitsRepeater.vue?vue&type=style&index=0&id=d484d146&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d484d146",
  null
  
)

export default component.exports